import axios from "../../../../apis/Api";
import history, { logout } from "../../../../history";
import storage from "../../../../apis/Storage";
import { GET_PROFILE_SETTING } from "../../../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";

export const getProfileSetting = () => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .get("api/User/GetProfileSetting")
    .then(({ data }) => {
      if (data.response)
        dispatch({
          type: GET_PROFILE_SETTING,
          payload: data.response,
        });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const updateProfileSetting = (fromdata) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/User/UpdateProfileSetting`, fromdata)
    .then(({ data }) => {
      toast.success("Profile Updated successfully");
      dispatch(hideLoading());
      setTimeout(() => {
        storage.set("_userFullName", fromdata.fullName);
        storage.set("_imageUrl", fromdata.image);
        history.push("/dashboard");
        history.go("/dashboard");
      }, 2000);
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const sendOtpToVerifyEmail = (fromdata) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/Authenticate/SendOtpToUserThroughEmail`, fromdata)
    .then(({ data }) => {
      toast.success("Your One-Time Password (OTP) Send On Your Email Address");
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const saveNewEmail = (fromdata) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/Authenticate/SaveNewEmail`, fromdata)
    .then(({ data }) => {
      if (data.isSuccess) {
        toast.success(data.message);
      } else {
        toast.info(data.message);
      }
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};
